module.exports = __webpack_public_path__ + "img/feature-cafeteria-videowall-menu.623f3e4d.png";